import { render, staticRenderFns } from "./CancelReason.vue?vue&type=template&id=1f1a1430&"
import script from "./CancelReason.vue?vue&type=script&lang=js&"
export * from "./CancelReason.vue?vue&type=script&lang=js&"
import style0 from "./CancelReason.vue?vue&type=style&index=0&id=1f1a1430&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports